module.exports = __webpack_public_path__ + "img/Pot1.3bdb0762.svg";